<template>
  <div class="parkApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" :element-loading-text="tsmsg" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <swiper :options="swiperOption">
      <swiper-slide class="swiper-slide games" >
        <a href=""><img :src="baseUrl+setScenic.img"></a>
      </swiper-slide>
    </swiper>
    <div class="cont">
      <div class="info">
        <h2 class="title"><div>{{setScenic.title}}</div>
          <span class="curt">{{setScenic.level}}级景区</span>
          <span>{{setScenic.read_num}}次查阅</span>
        </h2>
        <h2>景区地址：{{setScenic.address}}</h2>
        <h2 style="padding-bottom:10px">
          <p>周一至周日</p>
          <p>入场时间：{{setScenic.business}}</p>
          <p>{{setScenic.content}}</p>
          <p>以上信息仅供参考，具体以景区当日实际公示信息为准。</p>
        </h2>
        <h2 class="box">请选择入园门票
          <div class="right" @click="getPaycark"><font>{{cardName == '' ? '请选择' : cardName}}</font><i class="el-icon-arrow-right"></i></div>
        </h2>
        <h2 class="box">出行人信息
          <div class="right" @click="getUser"><font>{{userActivename == '' ? '请选择' : userActivename}}</font><i class="el-icon-arrow-right"></i></div>
        </h2>

        <h2 class="box">票务描述
          <div>
            <textarea placeholder="请输入票务描述" v-model="content"></textarea>
          </div>
        </h2>
        <div class="goDetail" @click="toPush(setScenic.scenic_id,'tkscenic')">详情<i class="el-icon-arrow-right"></i></div>
      </div>
      <div style="height:15px"></div>
    </div>
    <div style="height:20px"></div>
    <div class="footer1">
      <div class="foot-title">
        <span>{{orderId == '' || userId == '' ? '请选择入园门票' : '抵扣门票1张'}}</span>
      </div>
      <div class="pay" v-if="orderId == '' || userId == ''">
        <span style="background:#ccc">请选择门票信息</span>        
      </div>
      <div class="pay" v-if="orderId != '' || userId != ''">
        <span @click="save">确认入园</span>        
      </div>
    </div>


    <el-drawer title="选择入园门票" :visible.sync="drawer" :direction="direction" size="60%" :withHeader="true" :show-close="false">
      <ul>
        <li v-for="(item,i) in setPaycark">
          <div :class="active == item.id ? 'chooseInfo curt':'chooseInfo'">
            <font @click="tab(item.id,item.title,item.use,item.surplus,item.card_id,item.number)" v-if="item.status == 1 && item.surplus>0" :class="active == item.id ? 'el-icon-success':''"></font>
          </div>
          <div class="cardCon">
            <h2>{{item.title}}</h2>
            <p>有效时间：{{item.starttime}} ~ {{item.endtime}}</p>
            <p>
              <font>门票总数:<b>{{item.total}}</b>张</font>
              <font>已使用:<b>{{item.use}}</b>张</font>
              <font>剩余:<b>{{item.surplus}}</b>张</font>
            </p>
          </div>
          <div class="status" :style="item.status == 1 ? '' : 'color:red'">{{item.status == 1 ? (item.surplus <=0 ? '已用完' : '有效中') : '已过期'}}</div>
        </li>
      </ul>
      <div class="yesBtn">
        <i class="el-icon-close" @click="drawer = false"></i>
        <a v-if="active !=''" @click="yesCard">确定</a>
      </div>
    </el-drawer>

    <el-drawer title="选择出行人" :visible.sync="drawer1" direction="btt" size="60%" :withHeader="true" :show-close="false">
      <ul>
        <li v-for="(item,i) in setUser">
          <div style="margin-top:13px" :class="userActive == item.id ? 'chooseInfo curt':'chooseInfo'">
            <font @click="tabUser(item.id,item.name,item.card)" :class="userActive == item.id ? 'el-icon-success':''"></font>
          </div>
          <div class="cardCon">
            <h2>{{item.name}}</h2>
            <p>身份证：{{item.card}}</p>
          </div>
        </li>
      </ul>
      <div class="yesBtn">
        <i class="el-icon-close" @click="drawer1 = false"></i>
        <a v-if="userActive !=''" @click="yesUser">确定</a>
      </div>
    </el-drawer>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        userData:[],
        tsmsg:'数据加载中',
        swiperOption: {
          autoplay : {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 1000 //自自动循环时间
          }, //可选选项，自动滑动
          initialSlide: 0,
          speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop:false, //循环切换
          grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
          observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
       
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },
        dialogFormVisible: false,
        timer:'',
        djstimer:0,
        images:'',

        drawer:false,
        drawer1:false,
        direction: 'btt',
        active:'',
        activeName:'',
        cardName:'',
        orderId:'',

        userActive:'',
        userActivename:'',
        userName:'',
        userId:'',
        setScenic:[],
        setPaycark:[],
        setUser:[],
        arr:[],
        study:[],
        use:0,
        surplus:0,
        cardArr:[],
        idcard:'',

        content:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/oDetail?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getScenic();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      getScenic:function(e){
        var that = this;
        var id = that.$route.query.id;
        this.axios({
          'url': that.$host+'home/ticket/ticketDetail',
          'method': 'post',
          params:{
            id:id,
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setScenic = res;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      getPaycark:function(){
        var that = this;
        var id = that.setScenic.scenic_id;
        that.fullscreenLoading = true;
        that.axios({
          'url': that.$host+'home/park/payCard',
          'method': 'post',
          params:{
            user_id:that.userData.id,
            s_id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setPaycark = res;
          that.drawer = true;
          that.active = '';
          that.cardName = '';
          that.activeName = '';
          that.orderId = '';
          that.use = 0;
          that.surplus= 0;
          that.cardArr = [];
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false;
        });
      },

      tab:function(id,title,use,surplus,card_id,number){
        var arr = [];
        arr.push(id,title,use,surplus,card_id,number);
        this.active = id;
        this.activeName = title;
        this.use = use;
        this.surplus= surplus;
        this.cardArr = arr
      },
      yesCard:function(){
        this.cardName = this.activeName
        this.orderId = this.active;
        this.drawer = false;
      },

      tabUser:function(id,name,idcard){
        this.userActive = id;
        this.userActivename = name;
        this.idcard = idcard
      },
      yesUser:function(){
        this.userName = this.userActivename
        this.userId = this.userActive;
        this.drawer1 = false;
      },

      getUser:function(){
        var that = this;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/park/user',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setUser = res;
          that.drawer1 = true;
          that.userActive = '';
          that.userActivename = '';
          that.userName = '';
          that.userId = '';
          that.idcard = '';
          that.fullscreenLoading = false;
        }).catch(err=>{
          that.fullscreenLoading = false
        });
      },
      save:function(){
        var that = this;
        if(that.orderId == '' && that.userId != ''){
          that.$alert('请选择入园信息!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        that.tsmsg = '正在出票中...';
        that.fullscreenLoading = true;
        that.axios({
          'url': that.$host+'home/ticket/save',
          'method': 'post',
          params:{
            user_id:that.userData.id,
            content:that.content,
            name:that.userName,
            s_id:that.setScenic.scenic_id,
            title:that.setScenic.title,
            num:1,
            order_id:that.orderId,
            idCard:that.idcard,
            card_id:that.cardArr[4],
            number:that.cardArr[5]
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          var res = response.data.data
          if(response.data.status == 200){

            that.active = '';
            that.cardName = '';
            that.activeName = '';
            that.orderId = '';
            that.cardArr = [];

            that.userActive = '';
            that.userActivename = '';
            that.userName = '';
            that.userId = '';
            that.idcard = '';
            that.tsmsg = '数据加载中';
            that.$alert('出票申请成功，系统会在一个小时内生成票据，请关注“职工生活家”公众号，关注成功后会有消息提醒您出票情况!', '提示', {
              confirmButtonText: '确定',
              showClose:false,
              callback: action => {
                that.toPush(response.data.data,'imsuccess')
              }
            });
          }else{
            that.$alert(response.data.message, '提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },


      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .el-dialog{
    width:90% !important;
    border-radius:6px;
  }
  .el-dialog__body{
    padding:20px 20px 0 20px !important;
  }
  .el-form-item__content{
    margin-left:0 !important
  }
  .el-form-item__label{
    text-align:left
  }
  .parkApp{
    max-width:640px;
    background:#f1f1f1;
    margin:0 auto;
  }
  .parkApp .swiper-slide{
    width:100%
  }
  .parkApp .swiper-slide img{
    display:block;
    width:100%;
  }
  .parkApp .cont{
    width:94%;
    display:block;
    margin:0 auto;
    z-index:99;
    position:relative;
    top:-60px;
  }
  .parkApp .info{
    width:100%;
    display:block;
    position:relative;
    background:#fff;
    border-radius:6px;
  }
  .parkApp .info .goDetail{
    position:absolute;
    right:3%;
    transform: translateY(-50%);
    top:20%;
    font-size:14px;
    color:#666
  }
  .parkApp .info h2{
    font-size:15px;
    padding-top:10px;
    width:92%;
    display:block;
    margin:0 auto;
    font-weight:normal;
    color:#333;
  }
  .parkApp .info h2.box{
    border-top:solid 1px #f5f5f5;
    padding:18px 0;
    color:#666
  }
  .parkApp .info h2 .right{
    float:right;
    width:60%;
    text-align:right
  }
  .parkApp .info h2 .right font{
    color:#ff5555;
    float:left;
    width:90%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .parkApp .info h2 textarea{
    outline:none;
    border:solid 1px #ececec;
    font-size:15px;
    width:96%;
    color:#666;
    height:70px;
    background:#fff;
    border-radius:5px;
    padding:5px 2%;
    margin-top:8px;
    resize: none
  }
  .parkApp .info h2 .right i{
    float:right;
    margin-top:2px
  }
  .parkApp .info h2 p{
    padding-bottom:5px;
    line-height:22px
  }
  .parkApp .info h2.title{
    color:#000;
    font-weight:bold;
    font-size:16px;
    padding:15px 0 12px 0
  }
  .parkApp .info h2.title div{
    margin-bottom:8px
  }
  .parkApp .info h2.title span{
    font-weight:normal;
    display:inlie-block;
    border:solid 1px #F56C6C;
    font-size:12px;
    padding:3px 5px;
    border-radius: 4px;
    color:#F56C6C;
    margin-right:8px;
  }
  .parkApp .info h2.title span.curt{
    color:#67C23A;
    border-color:#67C23A
  }
  .parkApp .info h2 a{
    color:#2F78FF;
    text-decoration: none;
  }

  .parkApp .card{
    width:100%;
    display:block;
  }
  .parkApp .card h2{
    font-size:16px;
    position:relative;
    padding:15px 0 10px 10px
  }
  .parkApp .card h2 font{
    font-size:12px;
    font-weight:normal;
    color:#666;
    padding-left:10px
  }
  .parkApp .card h2:after{
    content:'';
    width: 3px;
    height: 15px;
    background: #141EF1;
    position:absolute;
    left:0px;
    top:19px;
    border-radius: 3px;
  }
  .parkApp .card ul{
    width:100%;
    display:block;
    margin:0 auto;
    background:#fff;
    border-radius:6px;
    padding:15px 0 10px 0
  }
  .parkApp .card ul li{
    background:#f5f5f5;
    border-radius:6px;
    width:92%;
    margin:0 auto 10px auto;
    position:relative;
  }
  .parkApp .card ul li h3{
    font-size:16px;
    padding:15px 15px 10px 15px;
    width:75%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    color:#333
  }

  .parkApp .card ul li .price{
    font-size:15px;
    padding:0 15px 10px 15px;
    color:#999
  }
  .parkApp .card ul li .rate{
    font-size:15px;
    padding:0 15px 5px 15px;
    color:#999
  }
  .parkApp .card ul li .price font{
    color:#999;
    font-size:15px;
  }
  .parkApp .card ul li .price b{
    color: #f00;
    font-size:17px;
    font-weight:bold;
  }

  .parkApp .card ul li .price i{
    color: #f00;
    font-size:12px;
    font-style:normal
  }
  .parkApp .card ul li .price span{
    text-decoration: line-through;
    padding-left:8px;
    font-size:12px
  }
  .parkApp .card ul li a{
    position:absolute;
    right:20px;
    top:60%;
    background: linear-gradient(90deg, #F79169, #FFAA3B);
    transform: translateY(-50%);
    color:#fff;
    border-radius: 30px;
    width: 65px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-size:14px;
  }
  .parkApp .study h2{
    font-size:16px;
    position:relative;
    padding:15px 0 10px 10px
  }
  .parkApp .study h2:after{
    content:'';
    width: 3px;
    height: 15px;
    background: #141EF1;
    position:absolute;
    left:0px;
    top:19px;
    border-radius: 3px;
  }
  .parkApp .study ul{
    width: 100%;
    background:#fff;
    padding-top:15px
  }
  .parkApp .study ul li{
    width: 92%;
    background:#fff;
    border-radius: 5px;
    margin:0 auto 12px auto;
    border-bottom:1px solid #f5f5f5;
    padding-bottom:10px
  }
  .parkApp .study ul li:last-child{
    border-bottom:0
  }
  .parkApp .study ul li:after{
    clear: both;
    content: '.';
    display: block;
    width: 0;
    height: 0;
    visibility: hidden;
  }
  .parkApp .study ul li .el-image{
    float:left;
    width:25%;
    height:70px;
  }
  .parkApp .study ul li .el-image__inner{
    border-radius:5px;
  }
  .parkApp .study ul li .left{
    float:left;
    width:75%
  }
  .parkApp .study ul li h3{
    display:block;
    font-size:15px;
    letter-spacing:1px;
    padding:0px 0px 0px 10px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:1;
    overflow: hidden;
    color:#000;
    padding-bottom:4px
  }
  .parkApp .study ul li .source{
    padding: 0 10px 0px 5px
  }
  .parkApp .study ul li .source:after{
    content:"";
    display: block;
    clear:both;
  }
  .parkApp .study ul li .source img{
    width:25px;
    border-radius:50%;
    float:left;
    margin-left:10px;
  }
  .parkApp .study ul li .source span{
    float:left;
    color:#333;
    font-size:14px;
    height:25px;
    line-height:25px;
    margin-left:5px;
  }
  .parkApp .study ul li .source font{
    float:right;
    color:#333;
    font-size:14px;
    height:25px;
    line-height:25px;
  }
  .parkApp .study ul li .source font img{
    width:16px;
    position:relative;
    top:3px;
    margin-right:3px
  }


  .parkApp .el-drawer__open .el-drawer.btt{
    border-radius:16px 16px 0 0;
  }
  .parkApp .el-drawer__header{
    margin:0 auto !important;
    padding:0 3%;
    height:50px;
    width:94%;
    position: absolute;
    top:0;
    left:0%;
    z-index:999;
    border-bottom:1px #f5f5f5 solid;
    background:#fff;
    text-align:center;
    color:#000
  }
  .parkApp .yesBtn{
    width:100%;
    position: absolute;
    top:0;
    left:0%;
    height:50px;
    z-index:9999;
  }
  .parkApp .yesBtn a{
    float:right;
    margin-right:4%;
    height:50px;
    line-height:50px;
    color:#0059D6;
    font-size:15px;
    letter-spacing:1px
  }
  .parkApp .yesBtn i{
    float:left;
    margin-left:4%;
    height:50px;
    line-height:50px;
    color:#000;
    font-size:18px
  }
  .parkApp .el-drawer__body ul{
    padding-top:65px;
  }
  .parkApp .el-drawer__body ul li{
    width:92%;
    margin:0 auto;
    border-bottom:solid 1px #f5f5f5;
    margin-bottom:15px;
    padding-bottom:15px;
  }
  .parkApp .el-drawer__body ul li:last-child{
    border-bottom:none;
    padding-bottom:0;
  }
  .parkApp .el-drawer__body ul li:after{
    content: '';
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
  }
  .parkApp .el-drawer__body ul li .chooseInfo{
    float:left;
    width:20px;
    height:20px;
    margin-top:23px;
    margin-right:4%
  }
  .parkApp .el-drawer__body ul li .chooseInfo font{
    display:block;
    width:20px;
    height:20px;
    border:solid #000000 1px;
    border-radius:50%;
    line-height:20px;
    color:#000
  }
  .parkApp .el-drawer__body ul li .curt font{
    border:none;
    font-size:23px;
  }
  .parkApp .el-drawer__body ul li .cardCon{
    float:left;
    width:72%
  }
  .parkApp .el-drawer__body ul li .cardCon h2{
    font-size:15px;
    letter-spacing:1px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .parkApp .el-drawer__body ul li .cardCon p{
    font-size:13px;
    color:#666;
    padding-top:6px
  }
  .parkApp .el-drawer__body ul li .cardCon p font{
    padding-right:10px;
  }
  .parkApp .el-drawer__body ul li .cardCon p font b{
    color:#0059D6;
    padding-right:1px
  }
  .parkApp .el-drawer__body ul li .status{
    float:right;
    font-size:13px;
    color:#333;
    line-height:66px
  }


  .parkApp .footer1{
    height: 60px;
    background: #fff;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0;
    z-index: 99
  }
  .parkApp .footer1 .foot-title{
    float: left;
    margin-left: 4%;
    height:60px;
    line-height:60px;
  }
  .parkApp .footer1 .foot-title span{
    font-size: 14px;
    color: #727272;
  }

  .parkApp .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 4%;
    margin-top:5px;
    width:50%
  }
  .parkApp .footer1 .pay span{
    float:left;
    height:50px;
    line-height:50px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #f00;
    border-radius:50px;
  }

  .parkApp .jbht{
    border:4px dashed #ffd700;
    padding-top:15px;
    position:relative;
    bottom:15px;
    border-radius: 6px;
  }
  .parkApp .jbht span{
    position:absolute;
    top:-15px;
    right:-15px;
    color:#f00;
    font-weight:bold;
    border:4px dashed #ffd700;
    border-radius: 50%;
    width:30px;
    height:30px;
    background:#fff;
    font-size:15px;
    line-height:30px;
    text-align:center
  }

  .parkApp .gggg{
    color:red;;
    font-size:18px;
    padding-bottom:35px;
    text-align:center;
  }
  .parkApp #avatar{
    border-radius:50%;
    width:80px;
    display:block;
    margin:0 auto
  }
  .parkApp #username{
    text-align:center;
    font-size:18px;
    color:#000;
    padding:10px 0
  }
  .parkApp .c55{
    width:98%;
    display:block;
    margin:0 auto;
    background: #F7FAFF;
    border-radius: 10px;
  }
  .parkApp .c55 #username{
    color:#666;
    font-size:15px;
  }
  .parkApp .c55 #username font{
    color:#2F78FF
  }
</style>